export default __webpack_public_path__ + "static/media/skipants.1e28363e.svg";